import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {CmcPlcSupplier} from '../cmc-points-de-livraison-resolver.service';
import {Subscription} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {ContratsMenusConvivesService} from '../../../../core/services/gestioncontrats/contrats-menus-convives.service';
import {RoutemapService} from '../../../../core/services/routemap.service';
import {PointDeLivraisonService} from '../../../../core/services/entities/point-de-livraison.service';
import {UtilsService} from '../../../../core/utils/utils.service';
import {GenericDatagridService} from '../../../../core/services/generics/generic-datagrid.service';
import {PointDeLivraisonDTO} from '../../../../core/dtos/point-de-livraison-d-t-o';
import {ContratMenuConviveDTO} from '../../../../core/dtos/contratmenuconvive-dto';
import {ContratMenuConviveRepasDTO} from '../../../../core/dtos/contratmenuconviverepas-dto';
import {DecoupageRepasDTO} from '../../../../core/dtos/decoupagerepas-dto';
import {ContratMenuConviveDecoupageDTO} from '../../../../core/dtos/contratmenuconvivedecoupage-dto';
import {HELP_FOLDERS, JourSemaine, MSG_KEY, MSG_SEVERITY} from '../../../../core/constants';
import {RepasDTO} from '../../../../core/dtos/repas-dto';
import {cloneDeep as _cloneDeep} from 'lodash';
import {DialogMsgSupplier, Paragraphe} from '../../../../core/suppliers/dialog-msg-supplier';
import {ContratMenuConviveDecoupage__PlcDTO} from '../../../../core/dtos/contratmenuconvivedecoupage__plc-dto';
import {CmcMnService} from '../../../../core/services/entities/cmc-mn.service';
import {ContratMenuConvive__ModeleNutriDTO} from '../../../../core/dtos/contratmenuconvive__modele-nutri-dto';
import {Cmcr__CmcCa__PlcDto} from '../../../../core/dtos/cmcr__cmcca__plc-dto';
import {animate, style, transition, trigger} from '@angular/animations';
import {DomSanitizer} from '@angular/platform-browser';
import {ToastService} from '../../../../core/services/technique/toast.service';
import {RegimeAlimentaireDTO} from '../../../../core/dtos/regime-alimentaire-dto';
import {ButtonThemeEnum} from '../../../../shared/ui/button/button-theme-enum';
import {PlatItem} from '../../../../core/dtos/plat-item';
import {IconThemeEnum} from '../../../../shared/ui/icon/icon-theme-enum';

/**
 * Colonne dynamique de la grille : un decoupage repas
 */
interface DecoupageColumn {
  name: string;
  caption: string;
  calculateCellValue: (row: ContratMenuConviveRepasDTO) => ContratMenuConviveDecoupageDTO;
}

/**
 * Entrée du menu de modification en masse
 */
interface EditPlanningItem {
  label: string;
  action: () => void;
}

@Component({
    selector: 'yo-cmc-point-de-livraison',
    templateUrl: './cmc-point-de-livraison.component.html',
    styleUrls: ['./cmc-point-de-livraison.component.scss'],
    // les styles sont portés par la classe .yo-planning-plc-grid, qui joue le rôle de portée
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('triggerPeriode', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('0.7s', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                animate('0.3s', style({ opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
export class CmcPointDeLivraisonComponent implements OnInit, OnDestroy {

  /**
   * Hauteur d'une ligne dans une cellule (régime, effectif, coût, taux de prise).
   * Toutes les colonnes partagent ce rythme pour rester alignées ligne à ligne,
   * y compris entre la table figée et la table principale de la grille.
   * Doit rester synchronisé avec $cell-line-height du scss.
   */
  static readonly CELL_LINE_HEIGHT = 26;

  public readonly ButtonThemeEnum = ButtonThemeEnum;
  public readonly IconThemeEnum = IconThemeEnum;

  pointDeLivraison: PointDeLivraisonDTO;
  contratMenuConvive: ContratMenuConviveDTO;
  subscriptionRoute: Subscription;


  cmcdPlcList: ContratMenuConviveDecoupage__PlcDTO[] = [];
  cmcrCmcCaPlcList: Cmcr__CmcCa__PlcDto[] = [];
  periode: ContratMenuConvive__ModeleNutriDTO;

  rows: ContratMenuConviveRepasDTO[];
  cols: DecoupageRepasDTO[];
  rowGroupMetadata: any;
  cells: ContratMenuConviveDecoupageDTO[] = [];

  /**
   * Colonnes dynamiques de la grille, une par decoupage repas
   */
  decoupageColumnList: DecoupageColumn[] = [];

  joursSemaine: JourSemaine[] = [];
  repasList: RepasDTO[] = [];
  regimeList: RegimeAlimentaireDTO[] = [];
  decoupageRepasList: DecoupageRepasDTO[];
  maxPlats: number;
  platList: PlatItem[] = [];

  mapTaillesComposante: Map<string, number> = new Map();
  displayEffectifDialog = false;
  displayCoutDialog = false;
  displayTauxDePriseDialog = false;

  // menu de modification en masse
  editPlanningItemList: EditPlanningItem[] = [
    {label: 'Effectifs', action: () => this.displayEffectifDialog = true},
    {label: 'Coûts', action: () => this.displayCoutDialog = true},
    {label: 'Taux de prise', action: () => this.displayTauxDePriseDialog = true}
  ];

  /**
   * Régimes indexés par contrat_menu_convive_repas, pour éviter un filtre + tri à chaque rendu de cellule
   */
  private cmcrCmcCaPlcByRowIdMap: Map<number, Cmcr__CmcCa__PlcDto[]> = new Map();

  /**
   * Ids des lignes qui démarrent un groupe de jour, pour n'afficher le libellé du jour qu'une seule fois
   */
  private firstJourRowIdSet: Set<number> = new Set();

  /**
   * Régimes indexés par jour de la semaine, pour la coche globale d'un jour
   */
  private cmcrCmcCaPlcByJourMap: Map<number, Cmcr__CmcCa__PlcDto[]> = new Map();

  pathFile: string = HELP_FOLDERS.CONTRATS_MENUS_CONVIVES + '/contrats-menus-convives-point-livraison';

  constructor(public sanitizer: DomSanitizer,
              public utils: UtilsService,
              public cmcMnSvc: CmcMnService,
              public gds: GenericDatagridService,
              private route: ActivatedRoute,
              private contratsMenusConvivesSvc: ContratsMenusConvivesService,
              private routeMapSvc: RoutemapService,
              private pdlSvc: PointDeLivraisonService,
              private toastSvc: ToastService) {
  }

  ngOnInit() {
    this.iniRouteData();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subscriptionRoute);
  }

  iniRouteData = () => {
    this.subscriptionRoute = this.route.data
      .subscribe((data: { cmcPlcSupplier: CmcPlcSupplier }) => {

        this.contratMenuConvive = data.cmcPlcSupplier.contratMenuConvive;
        this.pointDeLivraison = data.cmcPlcSupplier.selectedPointDeLivraison;
        this.periode = data.cmcPlcSupplier.selectedPeriode;

        // on ne fait rien sur cette page si on n'a pas le point de livraison ou le cmc renseigné
        if (!this.utils.isNullOrEmpty(this.pointDeLivraison) && !this.utils.isNullOrEmpty(this.contratMenuConvive)) {

          this.rows = data.cmcPlcSupplier.rows;
          this.cols = data.cmcPlcSupplier.cols;
          this.cells = data.cmcPlcSupplier.cmcdList;
          this.cmcdPlcList = data.cmcPlcSupplier.cmcdPlcList;
          this.cmcrCmcCaPlcList = data.cmcPlcSupplier.cmcrCmcCaPlcList;
          this.joursSemaine = data.cmcPlcSupplier.joursSemaine;
          this.repasList = data.cmcPlcSupplier.repasList;
          this.regimeList = data.cmcPlcSupplier.cmccaList.map(cmcca => cmcca.regimeAlimentaire);
          this.maxPlats = data.cmcPlcSupplier.maxPlats;

          this.decoupageRepasList = _cloneDeep(this.cols);
          this.platList = this.getPlatList(this.maxPlats);
          this.rowGroupMetadata = this.utils.updateRowGroupMetaData(this.rows, 'idJourSemaine');
          this.decoupageColumnList = this.buildDecoupageColumnList(this.cols);
          this.buildCmcrCmcCaPlcByRowIdMap();
          this.buildCmcrCmcCaPlcByJourMap();
          this.buildFirstJourRowIdSet();

          this.repasList.forEach(repas => {
            repas.regimesAlimentaire = this.regimeList;
          });

          this.computeTailles(this.cmcdPlcList, this.cmcrCmcCaPlcList);
        }
      });
  };

  help = (): DialogMsgSupplier => {

    let dms = new DialogMsgSupplier();
    dms.title = `Taux de prise prévisionnels`;
    dms.logo = 'fa fa-question-circle  yoni-color';

    let p1: Paragraphe = new Paragraphe();
    p1.title = ``;
    p1.lines = [
      `Saisie des effectifs et des taux de prise prévisionnels pour "${this.pointDeLivraison.libelle}" sur la prestation "${this.contratMenuConvive.libelle}" .`,
    ];

    dms.content = {
      intro: ``,
      paragraphes: [p1]
    };

    return dms;
  };

  savePlanning = () => {
    this.cmcMnSvc.savePlanningPlc(this.periode.id, this.cmcdPlcList, this.cmcrCmcCaPlcList).subscribe(response => {
      if (!this.utils.isResponseSupplierError(response))
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Effectifs prévisionnels pour "${this.contratMenuConvive.libelle} - ${this.pointDeLivraison.libelle}" enregistrés avec succès`);
    });
  };

  getCell = (row: ContratMenuConviveRepasDTO, col: DecoupageRepasDTO) =>
    this.cells.find(cell => cell.contratMenuConviveRepasId === row.id && cell.decoupageRepasId === col.id);

  onEditPlanningItemClick = (event: { itemData?: EditPlanningItem }) => event.itemData?.action();

  /**
   * Marquer la cellule "jour" pour simuler une fusion verticale des lignes d'un même jour
   */
  onCellPrepared = (event) => {
    if (event.rowType === 'data' && event.column?.name === 'jour') {
      event.cellElement.classList.add(this.isFirstRowOfJour(event.data) ? 'jour-cell-start' : 'jour-cell-continue');
    }
  };

  isFirstRowOfJour = (row: ContratMenuConviveRepasDTO) => this.firstJourRowIdSet.has(row.id);

  private buildDecoupageColumnList = (cols: DecoupageRepasDTO[]): DecoupageColumn[] =>
    (cols || []).map(col => ({
      name: `decoupage-${col.id}`,
      caption: (col.libelle || '').toUpperCase(),
      calculateCellValue: (row: ContratMenuConviveRepasDTO) => this.getCell(row, col)
    }));

  private buildCmcrCmcCaPlcByRowIdMap = () => {
    this.cmcrCmcCaPlcByRowIdMap = new Map();

    this.rows.forEach(row => this.cmcrCmcCaPlcByRowIdMap.set(row.id,
      this.cmcrCmcCaPlcList
        .filter(item => item.idContratMenuConviveRepas === row.id)
        .sort((a, b) => (a.libelleRegime || '').localeCompare(b.libelleRegime || ''))));
  };

  private buildCmcrCmcCaPlcByJourMap = () => {
    this.cmcrCmcCaPlcByJourMap = new Map();

    this.cmcrCmcCaPlcList.forEach(item => {
      const list = this.cmcrCmcCaPlcByJourMap.get(item.idJourSemaine) || [];
      list.push(item);
      this.cmcrCmcCaPlcByJourMap.set(item.idJourSemaine, list);
    });
  };

  private buildFirstJourRowIdSet = () => {
    this.firstJourRowIdSet = new Set();

    Object.keys(this.rowGroupMetadata).forEach(idJourSemaine => {
      const row = this.rows[this.rowGroupMetadata[idJourSemaine].index];
      if (row) {
        this.firstJourRowIdSet.add(row.id);
      }
    });
  };

  /**
   * Une cellule affiche autant de lignes que le maximum entre son nombre de plats et son nombre de régimes
   */
  computeTailles = (cmcdPlcList: ContratMenuConviveDecoupage__PlcDTO[], cmcrCmcCaPlcList: Cmcr__CmcCa__PlcDto[]) => {
    this.mapTaillesComposante = new Map();

    if (this.utils.isCollectionNullOrEmpty(cmcdPlcList)) {
      return;
    }

    cmcdPlcList.forEach(value => {
      const keyComposanteTaille = this.keyComposanteTaille(value.idRepas, value.idJourSemaine);
      const nbRegimes = cmcrCmcCaPlcList
        .filter(item => item.idJourSemaine == value.idJourSemaine && item.idRepas == value.idRepas).length;
      const calcTailleComposante = Math.max(value.nombreChoixMaximum || 0, nbRegimes)
        * CmcPointDeLivraisonComponent.CELL_LINE_HEIGHT;

      // on garde la plus grande taille calculée pour un même jour / repas
      this.mapTaillesComposante.set(keyComposanteTaille,
        Math.max(calcTailleComposante, this.mapTaillesComposante.get(keyComposanteTaille) || 0));
    });
  };

  getPlatList = (maxPlats: number): PlatItem[] =>
    this.utils.getSlots(maxPlats).map(slot => ({label: 'Plat ' + (slot + 1), value: (slot + 1)}));

  getTailleComposante = (rowData: ContratMenuConviveRepasDTO) =>
    this.mapTaillesComposante.get(this.keyComposanteTaille(rowData.repasId, rowData.idJourSemaine))
    || CmcPointDeLivraisonComponent.CELL_LINE_HEIGHT;

  keyComposanteTaille = (repasId: number, idJourSemaine: number) => repasId + '-' + idJourSemaine;

  getCmcdPlc = (cell: ContratMenuConviveDecoupageDTO, ordre: number) =>
    this.cmcdPlcList.find(cmcdPlc => cmcdPlc.idContratMenuConviveDecoupage === cell.id && cmcdPlc.ordre === ordre);

  getAllCmcrCmcCaPlc = (row: ContratMenuConviveRepasDTO): Cmcr__CmcCa__PlcDto[] =>
    this.cmcrCmcCaPlcByRowIdMap.get(row.id) || [];

  /**
   * Régimes d'un jour, tous repas confondus
   */
  getAllCmcrCmcCaPlcByJour = (row: ContratMenuConviveRepasDTO): Cmcr__CmcCa__PlcDto[] =>
    this.cmcrCmcCaPlcByJourMap.get(row.idJourSemaine) || [];

  /**
   * Etat de la coche d'un jour, déduit des régimes de tous ses repas
   */
  getJourCheckValue = (row: ContratMenuConviveRepasDTO): boolean =>
    this.computeCheckValue(this.getAllCmcrCmcCaPlcByJour(row));

  /**
   * Etat de la coche d'un repas, déduit de ses régimes
   */
  getRepasCheckValue = (row: ContratMenuConviveRepasDTO): boolean =>
    this.computeCheckValue(this.getAllCmcrCmcCaPlc(row));

  /**
   * Repas fermé : tous ses régimes sont fermés, ses taux de prise ne sont plus saisissables.
   * Un repas sans régime n'est pas considéré comme fermé, pour ne pas bloquer la saisie.
   */
  isRepasFerme = (row: ContratMenuConviveRepasDTO): boolean => {
    const list = this.getAllCmcrCmcCaPlc(row);

    return !!list.length && list.every(item => !item.actif);
  };

  onJourCheckChange = (row: ContratMenuConviveRepasDTO, event) =>
    this.applyCheckValue(this.getAllCmcrCmcCaPlcByJour(row), event);

  onRepasCheckChange = (row: ContratMenuConviveRepasDTO, event) =>
    this.applyCheckValue(this.getAllCmcrCmcCaPlc(row), event);

  /**
   * Coche déduite d'un ensemble de régimes : cochée si tous sont ouverts, décochée si aucun,
   * indéterminée (null) si seulement une partie
   */
  private computeCheckValue = (cmcrCmcCaPlcList: Cmcr__CmcCa__PlcDto[]): boolean => {
    const nbActifs = cmcrCmcCaPlcList.filter(item => item.actif).length;

    if (!nbActifs) return false;

    return nbActifs === cmcrCmcCaPlcList.length ? true : null;
  };

  /**
   * Propagation d'une coche jour / repas sur ses régimes.
   * Les changements programmatiques (event.event absent) sont ignorés : la coche parente
   * est déduite des régimes, elle ne doit pas les réécrire quand elle se recalcule.
   */
  private applyCheckValue = (cmcrCmcCaPlcList: Cmcr__CmcCa__PlcDto[], event) => {
    if (!event.event) return;

    cmcrCmcCaPlcList.forEach(item => item.actif = !!event.value);
  };

}
